export { default as vuex } from './vuex'
